import { render, staticRenderFns } from "./ResearchOutputSearchAndList.vue?vue&type=template&id=04e42402&scoped=true&"
import script from "./ResearchOutputSearchAndList.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputSearchAndList.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputSearchAndList.vue?vue&type=style&index=0&id=04e42402&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e42402",
  null
  
)

export default component.exports